export default __webpack_public_path__ + "static/media/attendance_in_screen.a18dde60.gif";